<template>
<div class="fp-section-content">
    <slot></slot>
</div>
</template>

<script type="text/javascript">
import fullpage from "notone"

require('notone/fullpage.css')

export default {
    mounted () {
        fullpage.init('.fp-section-content',{
            threshold: 400,       // 触发滚动事件的阈值，越小越灵敏
            pageSpeed: 600,      // 滚屏速度，单位为毫秒 ms
            autoScroll: 0,      // 自动播放时间间隔，如果为 0 则不自动播放，单位 ms
            loopSection: false,          // Section循环滚动
            loopSlide: true,     // Slide循环滑动
            afterLoad: null,     // 页面载入事件，具体查看下面的 afterLoad 函数
            beforeLeave: null,    // 页面离开事件，具体查看下面的 beforeLeave 函数
            afterSlideLoad: null,       // slide 载入事件
            beforeSlideLeave: null      // slide 离开事件
        })
    }
}
</script>
<style type="text/css" lang="less">
.fp-section-content {
    .fp-section {
        min-height: 100vh;
    }
}
</style>


// WEBPACK FOOTER //
// FullPage.vue?ca61526a